import React, { useMemo, useRef, useEffect, useState, createContext, useContext } from 'react';
import { Link } from "react-router-dom";
import { TextInput, Text, StyleSheet } from 'react-native'
import { format, addDays, startOfWeek, endOfWeek, addWeeks, lastDayOfWeek, fromUnixTime } from 'date-fns';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Accordion from 'react-bootstrap/Accordion';
import Stack from 'react-bootstrap/Stack';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import { FaBookOpen, FaCalendarPlus, FaNotesMedical, FaSortAlphaDown, FaQuestionCircle, FaPhoneSquare, FaDog, FaMusic, FaMoon, FaSun, FaMapMarkedAlt, FaCheck, FaHospital, FaUserAstronaut, FaBullhorn, FaHeadSideCough, FaOpera, FaHandPointUp, FaScroll, FaIgloo, FaDownload, FaCar, FaSyncAlt, FaWalking, FaBell, FaQuestion, FaTrashAlt, FaLightbulb, FaHamsa, FaCalendarDay, FaGhost, FaClock, FaHospitalUser, FaHistory, FaUmbrellaBeach, FaUserAltSlash } from "react-icons/fa";
// import MasterAppt from './MasterAppt.js';
import { ThemeContext } from '../context/ThemeContext.js';
import { toHaveFormValues } from '@testing-library/jest-dom/matchers.js';
import {
  DataGrid, SelectCellFormatter,
  SelectColumn,
  textEditor,
  Column,
} from 'react-data-grid';

const MasterPanel = () => {
  // Find out where to get data
  const apptsUrl = process.env.REACT_APP_APPTS_URL;
  const [isDev, setIsDev] = useState(apptsUrl.search('dev') > 0);
  const [curNow, setNow] = useState(new Date().toLocaleString());
  const [refreshInterval, setRefreshInterval] = useState(51000);
  const [showAlert, setShowAlert] = useState();
  const [alertTotal, setAlertTotal] = useState();
  const [tomTotal, setTomTotal] = useState();
  const [dayTotal, setDayTotal] = useState();
  const [alertList, setAlertList] = useState(false);
  const [showActive, setShowActive] = useState(0);
  const [apptActive, setApptActive] = useState(1);
  const [showPatient, setShowPatient] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [activeRec, setActiveRec] = useState(null);
  const [patientRec, setPatientRec] = useState(null);
  const [brassRec, setBrassRec] = useState(null);
  const [patientPhone, updPhone] = useState();
  const activeClose = () => setShowActive(0);
  const patientClose = () => setShowPatient(false);
  const helpClose = () => setShowHelp(false);
  const [stat1, setStat1] = useState(null);
  const [stat2, setStat2] = useState(null);
  const [stat3, setStat3] = useState(null);
  const [showFlash, setShowFlash] = useState(false);

  const theDate = new Date().toLocaleString();
  const filterDateFormat = 'MM/dd/yyyy';
  const btnNormal = "btn btn-sm btn-outline-info";
  const btnDelay = "btn btn-sm btn-outline-danger superbutt";
  const btnActive = 'active ' + btnNormal;
  const btnOn = "btn btn-sm btn-outline-warning superbutt";
  const btnHdr = "btn btn-sm btn-outline-info microbutt";
  const btnHdrOn = "btn btn-sm btn-outline-warning microbutt";
  const btnHdrActive = 'active ' + btnHdr;
  const btnWait = 'active ' + btnOn;
  const btnOk = "btn btn-sm btn-outline-success superbutt";
  const btnGood = 'active ' + btnOk;
  const btnSelect = "btn btn-sm btn-outline-light";
  const btnSelectOn = 'active ' + btnNormal;
  const sortStyles = (active) => active ? btnActive : btnNormal;
  // console.log('MasterPanel ThemeContext', ThemeContext);
  // console.log('MasterPanel theme', theme);

  const [theme, setTheme] = useState('dark');
  // const [themeClass, setThemethemeClass] = useState('rdg-dark');
  const [themeClass, setThemeClass] = useState('rdg-dark');

  const styles = createStyles(theme);
  // document.documentElement.style.cssText = "--color-scheme: dark";
  const remStyles = [styles.apptBase, styles.apptWaiting, styles.apptGood]
  const alertStyles = [styles.timeBase, styles.timeWaiting, styles.timeGood];
  // const waitToggle = [styles.apptBase, styles.apptWaiting]

  // Sort
  var SortBlob = { active: 3, type: 'onDate' };
  const sortBlob = () => localStorage.getItem('SortBlob') ? JSON.parse(localStorage.getItem('SortBlob')) : SortBlob;
  const clickSort = (memactive, memtype) => {
    // Handle filter blob ops
    // build a fresh blob and save it
    setSortActive(memactive);
    SortBlob.active = memactive;
    setSortType(memtype);
    SortBlob.type = memtype;
    localStorage.setItem('SortBlob', JSON.stringify(SortBlob));
  }
  const [sortType, setSortType] = useState(sortBlob().type);
  const [sortActive, setSortActive] = useState(sortBlob().active);
  function sortField(val) {
    if (Number.isNaN(val)) { return val.toLowerCase().trim() } else { return val }
  }

  // Org filter
  var OrgBlob = { active: false, select: false, orgs: [] };
  const orgBlob = () => localStorage.getItem('OrgBlob') ? JSON.parse(localStorage.getItem('OrgBlob')) : OrgBlob;
  const clickOrgs = (memactive, memselect, memclear) => {
    // Handle filter blob ops
    if (memclear) {
      setFilterOrgs([]);
      setOrgsActive(false);
      setOrgsSelect(false);
      localStorage.removeItem('OrgBlob');
    } else {
      // build a fresh blob and save it
      OrgBlob.orgs = filterOrgs;
      setOrgsActive(memactive);
      OrgBlob.active = orgsActive;
      setOrgsSelect(memselect);
      OrgBlob.select = orgsSelect;
      localStorage.setItem('OrgBlob', JSON.stringify(OrgBlob));
    }
    // OrgBlob(active: orgsActive, select: orgsSelect, orgs: filterOrgs)
  }
  const [orgs, setOrgs] = useState();
  const [filterOrgs, setFilterOrgs] = useState(orgBlob().orgs);
  const [orgsActive, setOrgsActive] = useState(orgBlob().active);
  const [orgsSelect, setOrgsSelect] = useState(orgBlob().select);

  // Interpreter filter
  var TechBlob = { active: false, select: false, techs: [] };
  const techBlob = () => localStorage.getItem('TechBlob') ? JSON.parse(localStorage.getItem('TechBlob')) : TechBlob;
  const clickTechs = (memactive, memselect, memclear) => {
    // Handle filter blob ops
    if (memclear) {
      setFilterTechs([]);
      setTechsActive(false);
      setTechsSelect(false);
      localStorage.removeItem('TechBlob');
    } else {
      setTechsActive(memactive);
      TechBlob.active = techsActive;
      setTechsSelect(memselect);
      TechBlob.select = techsSelect;
      TechBlob.techs = filterTechs;
      localStorage.setItem('TechBlob', JSON.stringify(TechBlob));
    }
  }
  const [techs, setTechs] = useState([]);
  const [filterTechs, setFilterTechs] = useState(techBlob().techs);
  const [techsActive, setTechsActive] = useState(techBlob().active);
  const [techsSelect, setTechsSelect] = useState(techBlob().select);

  // Location filter
  var LocBlob = { active: false, select: false, locs: [] };
  const locBlob = () => localStorage.getItem('LocBlob') ? JSON.parse(localStorage.getItem('LocBlob')) : LocBlob;
  const clickLocs = (memactive, memselect, memclear) => {
    // Handle filter blob ops
    if (memclear) {
      setFilterLocs([]);
      setLocsActive(false);
      setLocsSelect(false);
      localStorage.removeItem('LocBlob');
    } else {
      setLocsActive(memactive);
      LocBlob.active = locsActive;
      setLocsSelect(memselect);
      LocBlob.select = locsSelect;
      LocBlob.locs = filterLocs;
      localStorage.setItem('LocBlob', JSON.stringify(LocBlob));
    }
  }
  const [locs, setLocs] = useState([]);
  const [filterLocs, setFilterLocs] = useState(locBlob().locs);
  const [locsActive, setLocsActive] = useState(locBlob().active);
  const [locsSelect, setLocsSelect] = useState(locBlob().select);

  // Dates.. We create a number of data range beginning and end points
  const [filterToday, setToday] = useState(format(theDate, filterDateFormat));
  const [filterTomorrow, setTomorrow] = useState(format(addDays(theDate, 1), filterDateFormat));
  const [filter3rdDay, set3rd] = useState(format(addDays(theDate, 2), filterDateFormat));
  const [filter4thDay, set4th] = useState(format(addDays(theDate, 3), filterDateFormat));
  const [filter5thDay, set5th] = useState(format(addDays(theDate, 4), filterDateFormat));
  const [filterWeekBeg, setWeekBeg] = useState(format(startOfWeek(theDate), filterDateFormat));
  const [filterWeekEnd, setWeekEnd] = useState(format(endOfWeek(theDate), filterDateFormat));
  const [filterNextWeekBeg, setNextWeekBeg] = useState(format(startOfWeek(addWeeks(theDate, 1)), filterDateFormat));
  const [filterNextWeekEnd, setNextWeekEnd] = useState(format(endOfWeek(lastDayOfWeek(addWeeks(theDate, 1))), filterDateFormat));
  var DateBlob = { active: 3, beg: filterToday, end: filterTomorrow };
  const dateBlob = () => localStorage.getItem('DateBlob') ? JSON.parse(localStorage.getItem('DateBlob')) : DateBlob;
  const [filterActive, setActive] = useState(dateBlob().active);
  const [begDate, setBegDate] = useState(format(dateBlob().beg, filterDateFormat));
  const [endDate, setEndDate] = useState(format(dateBlob().end, filterDateFormat));
  const clickDate = (memactive, membeg, memend) => {
    // Handle filter blob ops
    setActive(memactive);
    DateBlob.active = memactive;
    setBegDate(membeg);
    DateBlob.beg = membeg;
    setEndDate(memend);
    DateBlob.end = memend;
    localStorage.setItem('DateBlob', JSON.stringify(DateBlob));
    // reset the heading totals
    //charcoal(membeg, memend);
  }

  // reminder filter
  var RemBlob = { active: 0, rem24: 0, remDay: 0 };
  const remBlob = () => localStorage.getItem('RemBlob') ? JSON.parse(localStorage.getItem('RemBlob')) : RemBlob;
  const clickRems = (memactive, mem24, memToday, memclear) => {
    // Handle filter blob ops. Also handles remembering values in the browser LocalStorage
    if (memclear) {
      setRem24(0);
      setRemDay(0);
      setReminderActive(0);
      localStorage.removeItem('RemBlob');
    } else {
      setReminderActive(memactive);
      RemBlob.active = memactive;
      setRem24(mem24);
      RemBlob.rem24 = mem24;
      setRemDay(memToday);
      RemBlob.remDay = memToday;
      localStorage.setItem('RemBlob', JSON.stringify(RemBlob));
    }
  }
  const [rem24, setRem24] = useState(remBlob().rem24);
  const [remDay, setRemDay] = useState(remBlob().remDay);
  const [filterReminderActive, setReminderActive] = useState(remBlob().active);

  // Status
  var StatBlob = { active: 0, status: [] };
  const statBlob = () => localStorage.getItem('StatBlob') ? JSON.parse(localStorage.getItem('StatBlob')) : StatBlob;
  const clickStats = (memactive, memclear) => {
    window.scrollTo(0, 0)
    // Handle filter blob ops
    if (memclear) {
      setStatActive(0);
      localStorage.removeItem('StatBlob');
    } else {
      setStatActive(memactive);
      StatBlob.active = memactive;
      localStorage.setItem('StatBlob', JSON.stringify(StatBlob));
    }
  }
  const [filterStat, setFilterStat] = useState(statBlob().status);
  const [filterStatActive, setStatActive] = useState(statBlob().active);

  // export
  const [exportActive, setExportActive] = useState(0);
  // get Master List
  const [masterlist, setMaster] = useState(null);
  const [displaylist, setDisplay] = useState(null);

  useEffect(() => {
    // http://139.177.205.178:2095/scraperextracts
    // https://ctrl2.cherry2024.com:2096/getservers
    window.scrollTo(0, 0);
    fetchMetrics();
    if (refreshInterval && refreshInterval > 0) {
      const interval = setInterval(refreshMaster, refreshInterval);
      return () => clearInterval(interval);
    }
  }, [refreshInterval, showAlert, alertTotal, tomTotal, dayTotal]);

  const fetchMetrics = () => {
    // retrieve and then setData()
    // `${apptsUrl}scraperextracts`
    fetch(`${apptsUrl}scraperextracts`)
      .then(response => response.json())
      .then(data => {
        setMaster(data);
        setDisplay(data);
        const orgArr = [];
        const techArr = [];
        const locArr = [];
        var altoto = 0;
        var rem24toto = 0;
        var remDaytoto = 0;
        data.forEach((val) => {
          if (!orgArr.includes(val.farmOrg)) {
            orgArr.push(val.farmOrg);
          }
          if (!techArr.includes(val.interpreter)) {
            techArr.push(val.interpreter);
          }
          if (!locArr.includes(val.apptLoc.slice(0, 15))) {
            locArr.push(val.apptLoc.slice(0, 15));
          }
          altoto = altoto + val.alCount;
          rem24toto = rem24toto + val.al24;
          remDaytoto = remDaytoto + val.alToday;
        });
        setOrgs(orgArr);
        setTechs(techArr);
        setLocs(locArr);
        setAlertTotal(altoto);
        setTomTotal(rem24toto);
        setDayTotal(remDaytoto);
      })
      .catch(error => console.error(error));
  }

  // Alert dosplay is controlled here
  const refreshMaster = () => {
    // update time
    setNow(format(new Date().toLocaleString(), 'eee h:mm:ss aaaa'));
    fetchMetrics();
    setShowAlert(alertTotal > 5);
  };

  const copy24 = async (toPaste) => {
    try {
      await navigator.clipboard.writeText(toPaste);
      setShowFlash(true);
      setTimeout(() => setShowFlash(false), 3000); // Hide after a while
      // console.log('Content copied to clipboard', toPaste);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  }

  const set24 = (rec) => {
    // retrieve and then setData()
    // rebuild the stat obj and stringify
    var apptState = {
      rem24: { last: 0, val: 0, locked: false, dist: 0 },
      remToday: { last: 0, val: 0, locked: false, dist: 0 },
      statEnRoute: { last: 0, val: 0, locked: false, dist: 0 },
      statDelayed: { last: 0, val: 0, locked: false, dist: 0 },
      statThere: { last: 0, val: 0, locked: false, dist: 0 },
      statWait: { last: 0, val: 0, locked: false, dist: 0 },
      statWith: { last: 0, val: 0, locked: false, dist: 0 },
      statComplete: { last: 0, val: 0, locked: false, dist: 0 },
      statNoShow: { last: 0, val: 0, locked: false, dist: 0 }
    };
    // setRem24({ last: format(new Date().toLocaleString(), 'HH:mm'), val: 1 })
    apptState = JSON.parse(rec.interState);
    if (!apptState) {
      apptState = {
        rem24: { last: format(new Date().toLocaleString(), 'HH:mm'), val: 1 },
        remToday: { last: 0, val: 0, locked: false, dist: 0 },
        statEnRoute: { last: 0, val: 0, locked: false, dist: 0 },
        statDelayed: { last: 0, val: 0, locked: false, dist: 0 },
        statThere: { last: 0, val: 0, locked: false, dist: 0 },
        statWait: { last: 0, val: 0, locked: false, dist: 0 },
        statWith: { last: 0, val: 0, locked: false, dist: 0 },
        statComplete: { last: 0, val: 0, locked: false, dist: 0 },
        statNoShow: { last: 0, val: 0, locked: false, dist: 0 }
      }
    }
    // copy24(`https://cherry2024.com/work/${rec.recid}`);
    // glue it all together into a link and click on it
    if ("parse" in URL) {
      // Build the sms
      let messageUrl = URL.parse(`sms:${encodeURIComponent(rec.interpreter.replace("(S)", ""))}&body=${encodeURIComponent(`https://cherry2024.com/work/${rec.recid}`)}`);
      const link = document.createElement("a");
      link.href = messageUrl;
      link.click();
    }
    apptState.rem24 = { last: format(new Date().toLocaleString(), 'HH:mm'), val: 1 };
    updAppt(rec, apptState);
  }

  const SetToday = (rec) => {
    // Set the Today reminder
    setRemDay({ last: format(new Date().toLocaleString(), 'HH:mm'), val: 1 })
    var apptState = JSON.parse(rec.interState);
    apptState.remToday = { last: format(new Date().toLocaleString(), 'HH:mm'), val: 1, locked: false, dist: 0 };
    updAppt(rec, apptState);
  }

  const activateAppt = (apptActive, rec) => {
    // Used by the OffCanvas to DeActivate/ReActivate an Appt
    // Also used by the Brass Ring process
    // isLive:
    // 1 = IsLive
    // 0 = ?
    // -1 DeActivate/ReActivate
    // -2 Brass Ring
    // -10 Unassigned (No Intterpreter): first import from AS
    // -11 Assigned (Has Interpreter now)
    // -20 Change Interpreter
    // -21 Change Appt Time
    // -22 Change Appt Loc
    // -23 Change Patient
    // var eventTime = format(new Date().toLocaleString(), 'HH:mm');
    setApptActive(apptActive);
    var updcmd = `${apptsUrl}updAppt?recid=${rec.recid}&isLive=${apptActive}`;
    // brass ring
    if (apptActive === -2) {
      updcmd = updcmd + "&interpreter=";
    }
    console.log(' updcmd:', updcmd);
    // retrieve and then setData()
    fetch(updcmd)
      .then(response => response.json())
      .then(data => {
        console.log("API Response:", data);
      })
      .catch(error => console.error(error));
    setShowActive(0);
  }

  const updAppt = (rec, apptState) => {
    // update the Appt with the new Reminders
    var updcmd = `${apptsUrl}updAppt?recid=${rec.recid}&interState='${JSON.stringify(apptState)}'`;
    console.log(' updcmd:', updcmd);
    // update
    fetch(updcmd)
      .then(response => response.json())
      .then(data => {
        console.log("updAppt API Response:", data);
      })
      .catch(error => console.error("updAppt API Error:", error));
  }

  const updPatient = async (patient) => {
    // set the new phone number (destructive)
    fetch(`${apptsUrl}updPatient?patient=${patient}&phone=${patientPhone}`)
      .then(response => response.json())
      .then(data => {
        console.log("updPatient API Response:", data);
      })
      .catch(error => console.error("updPatient API Error:", error));
  }

  function updClientContacted(rec) {
    // Toggle the Reminder Bell indicating the Client has been contacted.
    rec.clientState = true;
    var updcmd = `${apptsUrl}updAppt?recid=${rec.recid}&clientState=${rec.clientState}`;
    // console.log(updcmd);
    // update
    fetch(updcmd)
      .then(response => response.json())
      .then(data => {
        console.log(data);
      })
      .catch(error => console.error(error));
    return;
  }

  // Exports
  const exportsClose = () => setExportActive(false);
  const exportsShow = () => setExportActive(true);
  function exportCSV(exportType) {
    // This clears the nulls into strings
    const replacer = (key, value) => value ?? '';
    // The column names. This sets the columns for an extract  Object.keys(masterlist[0])
    var headerRow = [];
    var fileName = "newExport";
    switch (exportType) {
      case 'Outcomes':
        // The column names
        headerRow = ['apptClient', 'onDate', 'atWhen', 'isRush', 'apptHours', 'farmOrg', 'interpreter'];
        fileName = "Cherry2024ApptDetail";
        break;
      case 'ApptHours':
        // The column names
        headerRow = ['farmOrg', 'interpreter', 'apptHours'];
        fileName = "Cherry2024FarmTotals";
        break;
      case 'SayerHours':
        // The column names
        headerRow = ['interpreter', 'farmOrg', 'onDate', 'apptHours'];
        fileName = "Cherry2024TalkerTotals";
        break;
      default:
        break;
    }
    // make the rows
    const rowItems = selectedRows().map((row) =>
        headerRow.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(',')
      );
    // glue it all together into a link and click on it
    const csv = [headerRow, ...rowItems].join('\r\n');
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.download = fileName + ".csv";
    link.href = url;
    link.click();
  }

  const scrollTop = () => { window.scrollTo(0, 0); }

  //
  //
  // datagrid support
  //
  // This the the Grid Filter and Sort
  const selectedRows = () => {
    if (!displaylist) return [];
    return displaylist
      .sort((a, b) =>
      (sortField(a[sortType]) > sortField(b[sortType]) ? 1 :
        ((sortField(b[sortType]) > sortField(a[sortType])) ? -1 : 0)))
      .filter(appt => (
        ((appt.onDate >= begDate) && (appt.onDate <= endDate)) &&
        (!filterStatActive ||
          ((filterStatActive === 1) && (!appt.interState)) ||
          ((filterStatActive === 2) && (appt.interState) && (JSON.parse(appt.interState).statEnRoute.val === 1) && (JSON.parse(appt.interState).statThere.val === 0)) ||
          ((filterStatActive === 3) && (appt.interState) && (JSON.parse(appt.interState).statDelayed.val === 1) && (JSON.parse(appt.interState).statThere.val === 0)) ||
          ((filterStatActive === 4) && (appt.interState) && (JSON.parse(appt.interState).statThere.val === 1) && (JSON.parse(appt.interState).statComplete.val === 0)) ||
          ((filterStatActive === 5) && (appt.interState) && (JSON.parse(appt.interState).statWait.val === 1) && (JSON.parse(appt.interState).statComplete.val === 0)) ||
          ((filterStatActive === 6) && (appt.interState) && (JSON.parse(appt.interState).statWith.val === 1) && (JSON.parse(appt.interState).statComplete.val === 0)) ||
          ((filterStatActive === 7) && (appt.interState) && (JSON.parse(appt.interState).statComplete.val === 1)) ||
          ((filterStatActive === 8) && (appt.interState) && (JSON.parse(appt.interState).statNoShow.val === 1)) ||
          ((filterStatActive === 9) && (appt.isRush === 'On')) ||
          ((filterStatActive === 10) && (appt.isLive < -1)) ||
          ((filterStatActive === 11) && (appt.isLive === -1)) ||
          ((filterStatActive === 12) && (appt.apptNotes)) ||
          ((filterStatActive === 99) && (appt.alCount > 0))
        ) &&
        (!filterReminderActive ||
          ((filterReminderActive === 1) && (appt.interState) && (JSON.parse(appt.interState).rem24.val === rem24)) ||
          ((filterReminderActive === 2) && (appt.interState) && (JSON.parse(appt.interState).remToday.val === remDay))
        ) &&
        (!orgsActive || (orgsActive && filterOrgs && (Array.from(filterOrgs).includes(appt.farmOrg)))) &&
        (!techsActive || (techsActive && filterTechs && (Array.from(filterTechs).includes(appt.interpreter)))) &&
        (!locsActive || (locsActive && filterLocs && (Array.from(filterLocs).includes(appt.apptLoc.slice(0, 15)))))
      ));
  };

  const cellStatClass = (row) => {
    if (row.isLive === -1) {
      return 'apptInactive';
    }
    return undefined;
  };



  const rowStyle = { color: 'red' };

  function renderRow(key, props) {
    const style = props.row.alCount > 0 ? rowStyle : undefined;

    return (
      <>
        <props.row key={key} {...props} style={rowStyle} />;
      </>
    )

  }

  // Grid heading totals
  const summaryRows = useMemo(() => {
    var alTot = 0;
    var sayerTot = [];
    var dateTot = 0;
    var orgTot = [];
    var clientTot = [];
    var locTot = [];
    // Total accross all recs
    displaylist && displaylist.filter((r) => r.alCount).map((r) => (
      alTot = alTot + r.alCount
    ));
    // Total accros date range.
    displaylist && displaylist
      .filter((r) => ((r.onDate >= begDate) && (r.onDate <= endDate)))
      .forEach((r) => {
        !sayerTot.includes(r.interpreter) && sayerTot.push(r.interpreter);
        !clientTot.includes(r.apptClient) && clientTot.push(r.apptClient);
        !orgTot.includes(r.farmOrg) && orgTot.push(r.farmOrg);
        !locTot.includes(r.apptLoc.slice(0, 15)) && locTot.push(r.apptLoc.slice(0, 15));
        dateTot++;
      });
    return [
      {
        id: 'total_0',
        totalRecs: alTot,
        datesTotal: dateTot,
        totalSayers: sayerTot.length,
        totalClients: clientTot.length,
        totalRem24: displaylist ? displaylist.filter((r) => r.al24).length : 0,
        totalRemDay: displaylist ? displaylist.filter((r) => r.alToday).length : 0,
        totalEnRoute: displaylist ? displaylist.filter((r) => r.alEnRoute).length : 0,
        totalThere: displaylist ? displaylist.filter((r) => r.alThere).length : 0,
        totalPatient: displaylist ? displaylist.filter((r) => r.alPatient).length : 0,
        totalDone: displaylist ? displaylist.filter((r) => r.alDone).length : 0
      }
    ];
  }, [displaylist, begDate, endDate]);

  // DataGrid Column Definitions
  // This build the grid
  function getColumns(arg1, arg2) {
    return [
      {
        key: 'interpreter',
        name: 'Interpreter',
        frozen: true,
        width: 250,
        maxwidth: 350,
        renderHeaderCell() {
          return (<span>Interpreter &nbsp;
            <button className={btnHdr} title="Sort by INTERPRETER" onClick={() => clickSort(2, 'interpreter')}>
              <FaSortAlphaDown style={styles.btnHdr} /></button>&nbsp;
            &nbsp;
            <button className={techsActive ? btnHdrActive : btnHdr} title="Select INTERPRETERS" onClick={() => clickTechs(true, true, false)}><FaLightbulb /></button>&nbsp;
            <button className={techsActive ? btnHdrOn : btnHdr} title="Clear INTERPRETERS" onClick={() => clickTechs(false, false, true)}><FaTrashAlt /></button>&nbsp;
          </span >
          )
        },
        renderSummaryCell({ row }) {
          return (<span><span style={styles.colTots}>T: {row.totalSayers}</span>&nbsp;
            <button className={btnHdr} title="REFRESH PAGE" onClick={() => window.location.reload()}><FaSyncAlt /></button>
            <button className={(orgsActive || techsActive || locsActive) ? btnHdrOn : btnHdr} title="Clear Filters for ORGS, INTERPRETERS, and LOCS" onClick={() => [clickTechs(false, false, true), clickOrgs(false, false, true), clickLocs(false, false, true)]}><FaTrashAlt /></button>&nbsp;
            &nbsp;
            &nbsp;{alertTotal > 0 ? <span style={styles.isFail}>&nbsp;&nbsp;{alertTotal}</span> : <span style={{ color: 'limegreen' }}>Nadalerts</span>}</span>)
        },
        renderCell(props) {
          return (
            <span className="text-nowrap" title={props.row.interpreter} >
              {props.row.isLive === -1 && < FaGhost style={{ color: "grey" }} />}
              <Link target='_blank' to={`/talker/${props.row.interpreter.replace(/ /g, '').toUpperCase()}`}><FaBookOpen className='runningman' style={{ color: "darkred" }} />
              </Link>&nbsp;&nbsp;
              <Link className="text-nowrap" style={{ position: 'relative', textDecorationLine: 'none' }} target='_blank' to={`/admin/${props.row.recid}`}><FaHamsa />
                {(props.row.isLive === -2 || props.row.isLive === -3) && <FaOpera style={{ color: "darkgoldenrod" }} />}
                <span className="text-nowrap" style={styles.linktext}>&nbsp;&nbsp;{props.row.interpreter}</span>
              {props.row.isRush === 'On'
                  ? <span style={styles.rush} >&nbsp;RUSH</span>
                : <span>&nbsp;</span>
              }
              </Link>
            </span>
          );
        }
      },
      {
        key: 'al24', name: '24', frozen: true, width: 55, maxWidth: 120,
        renderSummaryCell({ row }) {
          return (tomTotal > 0 ? <span style={styles.isFail}>{tomTotal}</span> : <span></span>)
        },
        renderCell(props) {
          return (
            <>
              {props.row.al24 === 1 ? <span style={styles.failCell}>24</span> :
                props.row.rem24 ? <span style={alertStyles[props.row.remV24 ? props.row.remV24 : 0]}>{props.row.rem24}</span> : <span></span>}
            </>
          );
        }
      },
      {
        key: 'alToday', name: <FaCalendarDay />, frozen: true, width: 55, maxWidth: 120,
        renderSummaryCell({ row }) {
          return (dayTotal > 0 ? <span style={styles.isFail}>{dayTotal}</span> : <span></span>);
        },
        renderCell(props) {
          return (
            <>
              {props.row.alToday ? <FaCalendarDay style={styles.failCell} /> :
                props.row.remToday ? <span style={alertStyles[props.row.remVToday ? props.row.remVToday : 0]}>{props.row.remToday}</span> : <span></span>}
            </>
          );
        }
      },
      {
        key: 'alEnRoute', name: <FaCar />, frozen: true, width: 55, maxWidth: 120,
        renderSummaryCell({ row }) {
          return (<span style={styles.isFail}>{row.totalEnRoute > 0 && row.totalEnRoute}</span>);
        },
        renderCell(props) {
          return (
            <>
              {props.row.alEnRoute ? <FaCar style={styles.failCell} /> :
                props.row.statEnRoute ? <span style={styles.timeCell}>{props.row.statEnRoute}</span> : <span></span>}
            </>
          );
        }
      },
      {
        key: 'alThere', name: <FaHospitalUser />, frozen: true, width: 55, maxWidth: 120,
        renderSummaryCell({ row }) {
          return (<span style={styles.isFail}>{row.totalThere > 0 && row.totalThere}</span>);
        },
        renderCell(props) {
          return (
            <>
              {props.row.alThere ? <FaHospitalUser style={styles.failCell} /> :
                props.row.statThere ? <span style={styles.timeCell}>{props.row.statThere}</span> : <span></span>}
            </>
          );
        }
      },
      {
        key: 'alPatient', name: <FaHeadSideCough />, frozen: true, width: 55, maxWidth: 120,
        renderSummaryCell({ row }) {
          return (<span style={styles.isFail}>{row.totalPatient > 0 && row.totalPatient}</span>);
        },
        renderCell(props) {
          return (
            <>
              {props.row.alPatient ? <FaHeadSideCough style={styles.failCell} /> :
                (props.row.statWait || props.row.statWith) ? <span style={styles.timeCell}>{props.row.statWait || props.row.statWith}</span> : <span></span>}
            </>
          );
        }
      },
      {
        key: 'alDone', name: <FaUmbrellaBeach />, frozen: true, width: 55, maxWidth: 120,
        renderSummaryCell({ row }) {
          return (<span style={styles.isFail}>{row.totalDone > 0 && row.totalDone}</span>);
        },
        renderCell(props) {
          return (
            <>
              {props.row.alDone ? <FaUmbrellaBeach style={styles.failCell} /> :
                props.row.statComplete ? <span style={styles.timeCell}>{props.row.statComplete}</span> : <span></span>}
            </>
          );
        }
      },
      {
        key: 'recid', name: <FaBullhorn />, frozen: true, width: 35, minWidth: 35, 
        renderCell(props) {
          return (
            <Link target='_blank' to={`sms:${encodeURIComponent(props.row.interpreter.replace("(S)", ""))}&body=${encodeURIComponent(`https://cherry2024.com/work/${props.row.recid}`)}`}><FaBullhorn /></Link>
          );
        }
      },
      {
        key: 'rem24', name: '24', frozen: true,  width: 52, maxWidth: 65,
        renderCell(props) {
          return (
            <button style={remStyles[props.row.remV24 ? props.row.remV24 : 0]} className="btn btn-sm btn-outline-info" onClick={() => set24(props.row)}>24</button>
          );
        }
      },
      {
        key: 'remToday', name: <FaCalendarDay />, frozen: true, width: 52, maxWidth: 65,
        renderCell(props) {
          return (
            <button style={remStyles[props.row.remVToday ? props.row.remVToday : 0]} className="btn btn-sm btn-outline-info" onClick={() => SetToday(props.row)}><FaCalendarDay /></button>
          );
        }
      },
      {
        key: 'onDate', name: 'Date',  width: 120, frozen: true,
        cellClass(row) {
          return cellStatClass(row);
        },
        renderHeaderCell() {
          return (
            <span><FaCalendarPlus />  &nbsp;
              <button className={btnHdr} title="Sort by APPT TIME" onClick={() => clickSort(3, 'dateAppt')}>
                <FaSortAlphaDown />
              </button>
            </span >
          )
        },
        renderSummaryCell({ row }) {
          return (<span style={styles.colTots}>T: {row.datesTotal}</span>);
        },
        renderCell(props) {
          return (
            <span className="text-nowrap" style={styles.text1} >{format(props.row.onDate, 'EEEEEE')}&nbsp;{format(props.row.onDate, 'MMM do')}
            </span>
          );
        }
      },
      {
        key: 'atWhen', name: 'When',  width: 150, frozen: true, className: 'flex-nowrap',
        cellClass(row) {
          return cellStatClass(row);
        },
        renderHeaderCell() {
          return (<span>When &nbsp;
            <button className={btnHdr} title="SCROLL UP" onClick={() => scrollTop()}><FaScroll /><FaHandPointUp /></button>
            <button className={exportActive ? btnHdrActive : btnHdr} title="EXPORT DATA" onClick={() => [setExportActive(true), exportsShow]}><FaDownload /></button>
          </span >
          )
        },
        renderSummaryCell() {
          return (<span>{curNow}</span>);
        },
        renderCell(props) {
          return (
            <span className="text-nowrap" title={"ID:" + props.row.recid + " Days:" + props.row.ageDays + " Hrs:" + props.row.ageHours + " Mins:" + props.row.ageMins} style={styles.text1}>{props.row.atWhen}</span>
          );
        }
      },
      {
        key: 'apptClient',
        name: 'Client',
        frozen: true,
        width: 250,
        cellClass(row) {
          return cellStatClass(row);
        },
        renderHeaderCell() {
          return (<span>Client&nbsp;&nbsp;
            <button className={btnHdr} title="Sort by CLIENT NAME" onClick={() => clickSort(4, 'apptClient')}>
              <FaSortAlphaDown style={styles.btnHdr} />
            </button>&nbsp;
            {isDev ? <span className="runningman down">&nbsp;DEV</span> : <span className="runningman up">&nbsp;Live</span>}
          </span >
          )
        },
        renderSummaryCell({ row }) {
          return (<span style={styles.colTots}>T: {row.totalClients}</span>);
        },
        renderCell(props) {
          return (
            <span className="text-nowrap" title={props.row.apptClient} >
              {props.row.apptNotes &&
                <span><FaNotesMedical style={styles.btnHdr} title={props.row.apptNotes} />&nbsp;</span>}
              <span style={styles.nametext}>{props.row.apptClient}</span>
              {props.row.apptNotes &&
                <span>&nbsp;&nbsp;<span style={styles.text}>{props.row.apptNotes}</span></span>}
            </span>
          );
        }
      },

      {
        key: 'clientState',
        name: <FaBell />,
        width: 35,
        minWidth: 35,
        renderCell(props) {
          return (
            <a onClick={() => [updClientContacted(props.row)]}>
              {props.row.clientState
                ? <FaBell style={styles.contacted} />
                : <FaQuestion style={styles.notContacted} />
              }
            </a>
          );
        }
      },
      {
        key: 'sayerphone',
        name: 'Phone',
        
        renderCell(props) {
          return (
            <>
              <a onClick={() => [setShowPatient(true), setPatientRec(props.row), updPhone(props.row.sayerphone)]}><FaPhoneSquare style={styles.contacted} /></a>&nbsp;
              {props.row.sayerphone}
            </>
          );
        }
      },
      {
        key: 'apptLoc',
        name: 'Location',
        width: 350,
        renderHeaderCell() {
          return (<span>Location &nbsp;
            <button className={btnHdr} title="Sort by APPT LOCATION" onClick={() => clickSort(5, 'apptLoc')}><FaSortAlphaDown style={styles.btnHdr} /></button>&nbsp;
            &nbsp; &nbsp;
            <button className={locsActive ? btnHdrActive : btnHdr} title="Select LOCATIONS" onClick={() => clickLocs(true, true, false)}><FaLightbulb /></button>&nbsp;
            <button className={locsActive ? btnHdrOn : btnHdr} title="Clear LOCATIONS" onClick={() => clickLocs(false, false, true)}><FaTrashAlt /></button>&nbsp;
          </span >
          )
        },
        renderCell(props) {
          return (
            <span className='text-nowrap' title={props.row.apptLoc} style={styles.text1}>{props.row.apptLoc}</span>
          );
        }
      },
      {
        key: 'occID', name: 'Map', width: 50,
        renderSummaryCell() {
          return (<span>
            <button className={btnHdr} title="HELP" onClick={() => setShowHelp(true)}><FaQuestionCircle /></button>
          </span >
          )
        },
        renderCell(props) {
          return (
            <a target='_blank' rel='noopener noreferrer' href={"https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(props.row.apptAddr)}>Map</a>
          );
        }
      },
      {
        key: 'linkIgloo', name: 'Actions', width: 90, maxWidth: 90,
        cellClass(row) {
          return cellStatClass(row);
        },
        renderSummaryCell() {
          return (<span>
            <label className={btnHdr}>
              <select value={themeClass} onChange={(e) => setThemeClass(e.target.value)}>
                <option value="rdg-light">Light</option>
                <option value="rdg-dark">Dark</option>
                <option value="system">System</option>
              </select>
            </label>
          </span >
          )
        },
        renderCell(props) {
          return (
            <>
              <button style={styles.iconCell} className="btn btn-sm" onClick={() => copy24(`https://cherry2024.com/work/${props.row.recid}`)}><FaIgloo style={{ color: "green" }} /></button>&nbsp;
              <button style={styles.iconCell} className="btn btn-sm" onClick={() => ([setShowActive(2),
              setBrassRec(props.row)])}><FaOpera style={{ color: "darkgoldenrod" }} /></button>&nbsp;
              <button style={styles.iconCell} className="btn btn-sm" onClick={() => ([setShowActive(1),
              setActiveRec(props.row)])}><FaGhost style={{ color: 'gray' }} /></button>
            </>
          );
        }
      },
      {
        key: 'apptState', name: 'State', width: 70, 
        cellClass(row) {
          return cellStatClass(row);
        }
      },
      {
        key: 'apptAddr', name: 'Address', width: 200, className: 'text-nowrap', 
        renderHeaderCell() {
          return (<span>Address &nbsp; &nbsp; &nbsp;
            <button className={btnHdr} title="Sort by ADDRESS" onClick={() => clickSort(6, 'apptAddr')}><FaSortAlphaDown /></button>&nbsp;
          </span >
          )
        },
        renderCell(props) {
          return (
            <span className='text-nowrap' title={props.row.apptAddr} style={styles.nametext}>{props.row.apptAddr}</span>
          );
        }
      },
      {
        key: 'farmOrg', name: 'Org', width: 200, className: 'text-nowrap', 
        renderHeaderCell() {
          return (<span>Organization &nbsp; &nbsp; &nbsp;
            <button className={orgsActive ? btnHdrActive : btnHdr} title="Select ORGANIZATIONS" onClick={() => clickOrgs(true, true, false)}><FaLightbulb /></button>&nbsp;
            <button className={orgsActive ? btnHdrOn : btnHdr} title="Clear ORGANIZATIONS" onClick={() => clickOrgs(false, false, true)}><FaTrashAlt /></button>&nbsp;
          </span >
          )
        },
        renderCell(props) {
          return (
            <span className='text-nowrap' title={props.row.farmOrg} style={styles.nametext}>{props.row.farmOrg}</span>
          );
        }
      },
      {
        key: 'ageSecs', name: 'Age', width: 150, 
        renderCell(props) {
          return (
            <span style={{ color: "lightgreen", fontSize: "0.8em" }}>Min: {props.row.ageMins}  Hrs: {props.row.ageHours}  Days: {props.row.ageDays}</span>
          );
        }
      },
      {
        key: 'lastDist', name: 'D/D', width: 50, 
        renderCell(props) {
          return (
            <span style={{ color: "lightgreen", fontSize: "0.8em" }}>Dist: {props.row.lastDist}  Hrs: {props.row.apptHours}</span>
          );
        }
      },
    ];
  }

  return (
    <div>
      {displaylist ?
        <div>
          <div className="topLine1">
            &nbsp;Rem:&nbsp;
            <button style={remStyles[filterReminderActive || 0]} title="Clear REMINDER FILTERS" onClick={() => clickRems(0, 0, 0, true)}><FaTrashAlt /></button>&nbsp;
            <button style={remStyles[rem24]} title="Filter by 24HR REMINDER" onClick={() => clickRems(1, (rem24 + 1) % 3, remDay, false)} ><b>24</b></button>&nbsp;
            <button style={remStyles[remDay || 0]} title="Filter by TODAY REMINDER" onClick={() => clickRems(2, rem24, (remDay + 1) % 3, false)}><FaCalendarDay /></button>&nbsp;
            &nbsp;Stat:
            <button className={filterStatActive > 0 ? btnActive : btnNormal} title="Clear STATUS FILTERS" onClick={() => [clickStats(0, true)]}><FaTrashAlt /></button>&nbsp;
            <button className={99 === filterStatActive ? btnWait : btnDelay} title="Filter by ALERTS" onClick={() => clickStats(99)}><FaDog /></button>&nbsp;
            <button className={1 === filterStatActive ? btnActive : btnNormal} title="Filter by NO UPDATES YET" onClick={() => clickStats(1)}>Nada</button>&nbsp;
            <button className={2 === filterStatActive ? btnGood : btnOk} title="Filter by ENROUTE / STARTING" onClick={() => clickStats(2)}><FaCar /></button>&nbsp;
            <button className={3 === filterStatActive ? btnWait : btnDelay} title="Filter by DELAYED" onClick={() => clickStats(3)}><FaClock /></button>&nbsp;
            <button className={4 === filterStatActive ? btnGood : btnOk} title="Filter by THERE / ARRIVED" onClick={() => clickStats(4)}><FaHospitalUser /></button>&nbsp;
            <button className={5 === filterStatActive ? btnWait : btnOn} title="Filter by WAITING FOR PATIENT" onClick={() => clickStats(5)}><FaHistory /></button>&nbsp;
            <button className={6 === filterStatActive ? btnGood : btnOk} title="Filter by WITH PATIENT" onClick={() => clickStats(6)}><FaHeadSideCough /></button>&nbsp;
            <button className={8 === filterStatActive ? btnWait : btnOn} title="Filter by NO SHOW" onClick={() => clickStats(8)}><FaUserAltSlash /></button>&nbsp;
            <button className={7 === filterStatActive ? btnGood : btnOk} title="Filter by DONE" onClick={() => [clickStats(7)]}><FaWalking /><FaUmbrellaBeach /></button>&nbsp;
            <button className={9 === filterStatActive ? btnActive : btnNormal} title="Filter by RUSH" onClick={() => clickStats(9)}>RUSH</button>&nbsp;
            <button className={10 === filterStatActive ? btnWait : btnOn} title="Filter by BRASS RING" onClick={() => clickStats(10)}><FaOpera /></button>&nbsp;
            <button className={11 === filterStatActive ? btnActive : btnNormal} title="Filter by INACTIVE" onClick={() => clickStats(11)}><FaGhost /></button>&nbsp;
            <button className={12 === filterStatActive ? btnActive : btnNormal} title="Filter by NOTES" onClick={() => clickStats(12)}><FaMusic /></button>&nbsp;
            &nbsp;Day:&nbsp;
            <button className={1 === filterActive ? btnActive : btnNormal} title="View TODAY" onClick={() => clickDate(1, filterToday, filterToday)}>&nbsp;<FaCalendarDay />&nbsp;</button>&nbsp;
            <button className={2 === filterActive ? btnActive : btnNormal} title="View TOMORROW" onClick={() => clickDate(2, filterTomorrow, filterTomorrow)}><span className='sortWord'>{format(addDays(new Date(), 1).toLocaleString(), "eee")}</span><span className='sortIcon'>{format(addDays(new Date(), 1).toLocaleString(), "eeeeee")}</span></button>&nbsp;
            <button className={3 === filterActive ? btnActive : btnNormal} title="View TODAY and TOMORROW" onClick={() => clickDate(3, filterToday, filterTomorrow)}>Both</button>&nbsp;
            <button className={4 === filterActive ? btnActive : btnNormal} title="View DAY AFTER TOMORROW" onClick={() => clickDate(4, filter3rdDay, filter3rdDay)}><span className='sortWord'>{format(addDays(new Date(), 2).toLocaleString(), "eee")}</span><span className='sortIcon'>{format(addDays(new Date(), 2).toLocaleString(), "eeeeee")}</span></button>&nbsp;
            <button className={5 === filterActive ? btnActive : btnNormal} title="View DAY 4" onClick={() => clickDate(5, filter4thDay, filter4thDay)}><span className='sortWord'>{format(addDays(new Date(), 3).toLocaleString(), 'eee')}</span><span className='sortIcon'>{format(addDays(new Date(), 3).toLocaleString(), 'eeeeee')}</span></button>&nbsp;
            <button className={6 === filterActive ? btnActive : btnNormal} title="View DAY 5" onClick={() => clickDate(6, filter5thDay, filter5thDay)}><span className='sortWord'>{format(addDays(new Date(), 4).toLocaleString(), 'eee')}</span><span className='sortIcon'>{format(addDays(new Date(), 4).toLocaleString(), 'eeeeee')}</span></button>&nbsp;
            &nbsp;Week:&nbsp;
            <button className={7 === filterActive ? btnActive : btnNormal} title="Filter by THIS WEEK" onClick={() => clickDate(7, filterWeekBeg, filterWeekEnd)}>This</button>&nbsp;
            <button className={8 === filterActive ? btnActive : btnNormal} title="Filter by NEXT WEEK" onClick={() => clickDate(8, filterNextWeekBeg, filterNextWeekEnd)}>Next</button>&nbsp;
          </div>
          <Offcanvas show={exportActive} onHide={exportsClose} className="mt-2"
            data-bs-theme="dark">
            <Offcanvas.Header className="sidebarright">
              <Offcanvas.Title>Cherry2024 Exports&nbsp;&nbsp;&nbsp;</Offcanvas.Title>
              <button className="btn btn-sm btn-outline-warning" onClick={exportsClose}>Close</button>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Stack className="sidebarright" gap={3}>
                <div className="p-2 roweven row">
                  <span >&nbsp;This export contains the following columns:<br></br>
                    • Patient<br></br>
                    • Date<br></br>
                    • Status (Completed, No Show,etc)<br></br>
                    • Duration<br></br>
                    • Company<br></br>
                    • Interpreter<br></br>
                    &nbsp;<br></br>&nbsp;<br></br>&nbsp;
                    <button className={btnNormal} title="EXPORT APPOINTMENT DETAIL UPDATES" onClick={() => [exportCSV('Outcomes')]}>Click Here to Export<br></br>"Appointment Updates"</button>
                    <hr></hr>
                  </span>
                </div>
              </Stack>
            </Offcanvas.Body>
          </Offcanvas>
          <Offcanvas show={showAlert} className="mt-2" data-bs-theme="dark" placement='bottom'>
            <Offcanvas.Header className="sidebarright">
              <Offcanvas.Title>&nbsp;
                <Text style={styles.nametext}>&nbsp;&nbsp;<FaDog style={styles.failCell} />&nbsp;Alerts</Text></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <h3>There are Alerts</h3>
              <hr></hr>
              <button className={btnDelay} title="SHOW ALERTS" onClick={() => [clickStats(99), setShowAlert(false)]}>Chick Here to Show Alerts <FaDog style={styles.isFail} /></button>
              <hr></hr>
              <button className="btn btn-outline-warning" title="Close" onClick={() => setShowAlert(false)}>Ignore Alerts</button>&nbsp;
            </Offcanvas.Body>
          </Offcanvas>
          <Offcanvas show={showPatient} className="mt-2" data-bs-theme="dark">
            <Offcanvas.Header className="sidebarright">
              <Offcanvas.Title>&nbsp;<FaHeadSideCough />&nbsp;Patient Phone Number&nbsp;<FaHeadSideCough />&nbsp;</Offcanvas.Title>
              <button className="btn btn-sm btn-outline-warning" onClick={patientClose}>Close</button>
            </Offcanvas.Header>
            <Offcanvas.Body style={styles.text}>
              <Stack className="sidebarright" gap={3}>
                <div className="p-2 rowodd row-fluid">
                  Client:&nbsp;<Text style={styles.nametext} >{patientRec ? patientRec.apptClient : ''}&nbsp;&nbsp;&nbsp;</Text>
                  <hr></hr>
                  <h4>Enter Phone Number below:</h4>
                  <TextInput
                    style={styles.updPhone}
                    onChangeText={updPhone}
                    multiline='true'
                    value={patientPhone}
                    placeholder="Enter Phone Number Here"
                    keyboardType="default"
                  />
                </div>
                <div className="p-2 rowodd row-fluid">
                  <Button title="UPDATE PHONE NUMBER" onClick={() => [updPatient(patientRec ? patientRec.apptClient : ''), setShowPatient(false)]}>UPDATE Phone Number for {patientRec ? patientRec.apptClient : ''}</Button>
                  <hr></hr>
                  <span  >You are here to view/update the patient phone number.</span><br></br><br></br>
                  <span  >You can change it at any time. Enter a new phone number and Update.&nbsp;&nbsp;&nbsp;</span><br></br><br></br>
                  <span  >Enter a phone number and update or Close if all you needed was the number.&nbsp;&nbsp;&nbsp;</span><br></br>
                </div>
              </Stack>
            </Offcanvas.Body>
          </Offcanvas>
          <Offcanvas show={showActive === 1} className="mt-2" data-bs-theme="dark">
            <Offcanvas.Header className="sidebarright">
              <Offcanvas.Title>&nbsp;<FaGhost />&nbsp;Inactivate Appointment&nbsp;<FaGhost />&nbsp;</Offcanvas.Title>
              <button className="btn btn-sm btn-outline-warning" onClick={activeClose}>Close</button>
            </Offcanvas.Header>
            <Offcanvas.Body style={styles.text}>
              <Stack className="sidebarright" gap={3}>
                <div className="p-2 rowodd row-fluid">
                  Client:&nbsp;<Text style={styles.nametext} >{activeRec ? activeRec.apptClient : ''}&nbsp;&nbsp;&nbsp;</Text>
                </div>
                <div className="p-2 rowodd row-fluid">
                  Date:&nbsp;<Text style={styles.nametext} >{activeRec ? format(activeRec.onDate, 'MMM do') : ''}&nbsp;&nbsp;{activeRec ? activeRec.atWhen : ''}&nbsp;</Text><br></br>
                  Loc:&nbsp;<Text style={styles.nametext} >{activeRec ? activeRec.apptLoc : ''}</Text><br></br>{activeRec ? activeRec.apptAddr : ''}<br></br>
                  Org:&nbsp;<Text style={styles.nametext} >{activeRec ? activeRec.farmOrg : ''}</Text>
                </div>
                <div className="p-2 rowodd row-fluid">
                  <span >You are deactivating (removing) the current Appointment.</span><br></br><br></br>
                  <span >Click the buttons below to deactivate/reactivate this Apointment.</span><br></br>
                  <hr></hr>
                  <button title="DEACTIVATE" onClick={() => [activateAppt(-1, activeRec)]}>DeActivate Appointment for {activeRec ? activeRec.apptClient : ''}</button>
                  <hr></hr>
                  <button title="Bring It Back. REACTIVATE" onClick={() => [activateAppt(1, activeRec)]}>Bring It Back. ReActivate Appointment for {activeRec ? activeRec.apptClient : ''}</button>
                  <hr></hr>
                </div>
              </Stack>
            </Offcanvas.Body>
          </Offcanvas>
          <Offcanvas show={showActive === 2} className="mt-2" data-bs-theme="dark">
            <Offcanvas.Header className="sidebarright">
              <Offcanvas.Title>&nbsp;
                <Text style={styles.nametext}>&nbsp;&nbsp;<FaOpera style={{ color: "darkgoldenrod" }} />&nbsp;Brass Ring&nbsp;&nbsp;</Text></Offcanvas.Title>
              <button className="btn btn-sm btn-outline-warning" onClick={activeClose}>Close</button>
            </Offcanvas.Header>
            <Offcanvas.Body style={styles.text}>
              <Stack className="sidebarright" gap={3}>
                <div className="p-2 rowodd row-fluid">
                  Client:&nbsp;<Text style={styles.nametext} >{brassRec ? brassRec.apptClient : ''}&nbsp;&nbsp;&nbsp;</Text>
                </div>
                <div className="p-2 rowodd row-fluid">
                  Date:&nbsp;<Text style={styles.nametext} >{brassRec ? format(brassRec.onDate, 'MMM do') : ''}&nbsp;&nbsp;{brassRec ? brassRec.atWhen : ''}&nbsp;</Text><br></br>
                  Loc:&nbsp;<Text style={styles.nametext} >{brassRec ? brassRec.apptLoc : ''}</Text><br></br>{brassRec ? brassRec.apptAddr : ''}<br></br>
                  Org:&nbsp;<Text style={styles.nametext} >{brassRec ? brassRec.farmOrg : ''}</Text>
                </div>
                <div className="p-2 rowodd row-fluid">
                  You are removing the Interpreter |<Text style={styles.nametext} >{brassRec ? brassRec.interpreter : ''}</Text>| from the current Appointment. The Appointment will now join the UnAssigned.<br></br><br></br>
                  <span>&nbsp;Click the button below to UnAssign this Apointment.&nbsp;&nbsp;&nbsp;</span><br></br>
                </div>
                <div className="p-2 roweven row">
                  <button title="Remove the Current Interpreter from the Appoinment" onClick={() => [activateAppt(-2, brassRec)]}>Clear Interpreter for<br></br> {brassRec ? brassRec.apptClient : ''}</button>
                  <hr></hr>
                </div>
              </Stack>
            </Offcanvas.Body>
          </Offcanvas>
          <Offcanvas show={showHelp} className="mt-2" data-bs-theme="dark" placement='bottom'>
            <Offcanvas.Header className="sidebarright">
              <Offcanvas.Title>&nbsp;
                <Text style={styles.nametext}><FaQuestionCircle />&nbsp;&nbsp;Instructions for using the Cherry2024 Master List</Text>
                &nbsp;&nbsp;&nbsp;&nbsp;<button className="btn btn-sm btn-outline-warning" onClick={helpClose}>Close</button>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body style={styles.text}>
              <div>
                <h4>The Cherry2024 Appointment Master List</h4>
                <ul>
                  <li>You are here to work the master list of appointments in Cherry2024. Cherry2024 appointment tracking is made up of two pieces. This Master List (ML) and the single Appointment Links (AL) in the ML. The Admins work the ML and the Interpreters work the AL. Admins can also work the AL.
                  </li>
                  <li>In the ML, Admins can look at different date ranges using the Day or Week. You cannot go back to previous weeks.
                    You cannot go beyond next week. You use the filters to focus the list and make it easier to work with.
                  </li>
                  <li>
                    You can talk to the Interpreter by sending them messages or reminders (usually a Today <FaCalendarDay />).
                    <p>
                      To send a message (Apple iMessage), use the Megaphone <FaBullhorn /> to bring up a message containing the AL. Send this to the Interpreter requesting they respond.
                    </p>
                    <p>
                      If you send a reminder it goes yellow on the Master List and in the Appt Link. It is the Interpreter's responsibility
                      to respond to (acknowledge) the reminder. When the Interpreter responds in the Appt Link, it will go green in both Master List and the Appt Link. This is another way you know
                      the Interpreter it still working the Appt Link.
                    </p>
                  </li>
                  <li>
                    The ML is refreshed about once a minute. Changes made in the Appt Links will appear in the ML automatically. You can also manually refresh the ML using the button <FaSyncAlt />.
                  </li>
                  <li>
                    To get the exact location of the Appointment, click on the Map link in the ML or AL to open Google Maps.
                  </li>
                </ul>
              </div>
              <div>
                <h4>You do the following things to the Master List (ML)</h4>
                <ul>
                  <li>Sort (change the order of the list)</li>
                  <li>Filter (change the contents of the list). <br></br>
                    When you start to select a filter, the list goes empty. Appts that match your filter will appear as you select. If you decide to not use the filter, clear it and the list will come back.<br></br>
                    The Date filters can't be cleared. You must select a date range. The totals for the date range is in the column headings.
                  </li>
                  <li>Here are the icons and their meaning:<br></br>
                    <FaSyncAlt className="runningman" />=Refresh the page.<br></br>
                    <FaLightbulb className="runningman" />=Select entries for a Filter (Interpreter, Org, Location, Reminder, Status).<br></br>
                    <FaTrashAlt className="runningman" />=Clear the Filter.<br></br>
                    <FaDownload className="runningman" />=Export/Download.<br></br>
                    <FaHamsa className="runningman" />=Open the Appt Link in a new tab. You can also click on the Address.<br></br>
                    <FaCalendarDay className="runningman" />=24 Hour Reminder.<br></br>
                    <FaQuestion className="runningman" />=Client Not Contacted/Not Confirmed. Did somebody talk to this person and make sure they would be there?<br></br>
                    <FaBell className="runningman" />=Client Contacted/Confirmed. Somebody did talk to this person and to make sure they would be there.<br></br>
                    <FaGhost className="runningman" />=Deactivate. This stops the AL from working. If you only Deactivate, the Appt is cancelled and can no longer be updated.<br></br>
                    <FaOpera className="runningman" />=Brass Ring. Remove the current Interpreter from an Appoinment and allow it to be claimed by another Interpreter.<br></br>
                    <FaIgloo className="runningman" />=Copy the Appointment Link. This allows you to paste it into a browser. Most importantly, you can paste the link into a messaging application
                    and send it to an Interpreter
                    (like E-Mail, Everyday Messaging on a phone, Outlook, a Shared Google Calendar, Any Calendar, Safari, Chrome, Brave, Firefox, Opera, Any Web Browser, etc....).<br></br>
                    <FaBullhorn className="runningman" />=Open an iMessgae (Apple only). The Appt Link should be in the body of the message.
                  </li>
                </ul>
              </div>
              <div>
                <h4><FaOpera />&nbsp;Brass Ring&nbsp;<FaOpera /></h4>
                <ul>
                  <li>A Brass Ring Appointment does not have an Interpreter.<br></br>
                    Appointments can be loaded that do not have an Interpreter assigned. Also, you could decide to remove an Appointment from an Interpreter and give it to 1 or more other Interpreters.
                  </li>
                  <li>The Process:<br></br>
                    First you click on the Brass Ring and confirm it. This clears the Interpreter from the Appointment and sets the Appointment as a Brass Ring. Be sure you also clear the Intrpreter in AS.
                  </li>
                  <li>Send/Copy the Appt Link:<br></br>
                    Use the Megaphone to create an iMessage with the link of the Brass Ring Appointment. Use the Igloo to copy the link of the Brass Ring Appointment.
                  </li>
                  <li>Decide who gets a try at the Brass Ring:<br></br>
                    Imagine the Interpreters riding a carousel... It depends who gets the Brass Ring.
                  </li>
                  <li>Send the Brass Ring to a single Interpreter (not really a contest):<br></br>
                    Create an iMessage for that one Interpreter. They will be the only person that gets a chance to claim it.
                  </li>
                  <li>Send the Brass Ring to a group of Interpreters (first come, first serve):<br></br>
                    Create an iMessage and address it to a bunch of Interpreters you choose. If you want to create 3 iMessages, hit the Megaphone 3 times and you'll have 3 empty iMessages ready to go.
                  </li>
                  <li>The Interpreter that gets the link must claim the Appointment by entering their Name:<br></br>
                    The first Interpreter to update the Appointment claims it. They have grabbed the Brass Ring. Any following attempts to claim it will be ignored.
                  </li>
                  <li>The Admin can "Brass Ring" an Appointment as many times as needed:<br></br>
                    If an Interpreter fails or accidentally claims a Brass Ring, you can do it all over again.
                  </li>
                  <li>The Brass Ring filter (<FaOpera />) will show only Brass Ring Appts.
                  </li>
                </ul>
              </div>
              <div>
                <h4><FaGhost />&nbsp;De-Activating/Re-Activating an Appointment&nbsp;<FaGhost /></h4>
                <ul>
                  <li>"De-Activating" is the same as Deleting/Cancelling/Removing.<br></br>
                    Interpreters will not be able to make changes. The Appointment can still be seen in the Master List and it is colored differently for easy
                    identification. You are taking the Appointment away from the currently assigned Interpreter and ensuring no one works on it.
                  </li>
                  <li>"Re-Activating" is just an Undo for De-Activating.<br></br>
                    If you decide an Appointment that was De-Activated should be brought back to normal.
                  </li>
                  <li>The Ghost filter (<FaGhost />) will show only deactivated Appts.
                  </li>
                </ul>
              </div>
              <div>
                <h4>You send messages/reminders to the Interpreter.</h4>
                <ul>
                  <li>"24 Hour Reminder"</li>
                  <li>"Today Reminder"<br></br>
                    You can use the Today Reminder as many times as needed. If you want to see if an Interpreter is working the Appointment, you can send another "Today Reminder". If they do not respond, the may not be working the Appointment.
                  </li>
                </ul>
              </div>
              <div>
                <h4>For each Appt you have a Map button to open a tab to the Google Maps page for the Appt Location.</h4>
                <ul>
                  <li>If GPS is broken, you can use the Map Link to see the location of the AL or where you are.</li>
                </ul>
              </div>
              <div>
                <h4>You can see the current status of the Appt</h4>
                <ul>
                  <li>"24 Hour Reminder" (Blue=Not Sent,Yellow=Sent,Green=Confirmed)</li>
                  <li>"Today Reminder" (Blue=Not Sent,Yellow=Sent,Green=Confirmed)</li>
                  <li>"En Route" Confirmed [GPS] (Green)</li>
                  <li>"Interpreter Delayed" Sent [GPS] (Red)</li>
                  <li>"At Appointment" Confirmed [GPS] (Green)</li>
                  <li>"Waiting" Sent (Yellow)</li>
                  <li>"With Patient" Confirmed (Green)</li>
                  <li>"No Show" Sent (Yellow)</li>
                  <li>"Completed" Confirmed (Green)</li>
                </ul>
              </div>
            </Offcanvas.Body>
          </Offcanvas>
          {orgsSelect ?
            <Offcanvas show={orgsSelect} className="mt-2" data-bs-theme="dark" placement='bottom'>
              <Offcanvas.Body>
                <Text style={[styles.text]} >
                  <button className="btn btn-sm btn-outline-warning" title="Close ORGANIZATIONS" onClick={() => clickOrgs(true, false, false)}>Close</button>&nbsp;
                  {orgs
                    .map((item, index) => (
                      <button className={Array.from(filterOrgs).includes(item) ? btnSelectOn : btnSelect} onClick={() => setFilterOrgs([...filterOrgs, item])} key={index}>{item}
                      </button>
                    ))
                  }
                  <button className="btn btn-sm btn-outline-warning" title="Close ORGANIZATIONS" onClick={() => clickOrgs(true, false, false)}>Close</button>&nbsp;
                </Text>
              </Offcanvas.Body>
            </Offcanvas>
            : <span>&nbsp;</span>}
          {techsSelect ?
            <Offcanvas show={techsSelect} className="mt-2" data-bs-theme="dark" placement='bottom'>
              <Offcanvas.Body>
                <Text style={[styles.text]}>&nbsp;&nbsp;Talkers:&nbsp;
                  <button className="btn btn-sm btn-outline-warning" title="Close INTERPRETERS" onClick={() => clickTechs(true, false, false)}>Close</button>&nbsp;
                  {techs
                    .sort((a, b) =>
                      (a.toLowerCase() > b.toLowerCase()) ? 1 :
                        ((b.toLowerCase() > a.toLowerCase()) ? -1 : 0))
                    .map((item, index) => (
                      <button className={Array.from(filterTechs).includes(item) ? btnActive : btnNormal} onClick={() => setFilterTechs([...filterTechs, item])} key={index}>{item}
                      </button>
                    ))
                  }
                  <button className="btn btn-sm btn-outline-warning" title="Close INTERPRETERS" onClick={() => clickTechs(true, false, false)}>Close</button>&nbsp;
                </Text>
              </Offcanvas.Body>
            </Offcanvas>
            : <span>&nbsp;</span>}
          {locsSelect ?
            <Offcanvas show={locsSelect} className="mt-2" data-bs-theme="dark" placement='bottom' scroll="true" backdrop="true" >
              <Offcanvas.Body>
                <Text style={[styles.text]}>&nbsp;&nbsp;Locs:&nbsp;
                  <button className="btn btn-sm btn-outline-warning" title="Close LOCATIONS" onClick={() => clickLocs(true, false, false)}>Close</button>&nbsp;
                  {locs
                    .sort((a, b) =>
                      (a.toLowerCase() > b.toLowerCase()) ? 1 :
                        ((b.toLowerCase() > a.toLowerCase()) ? -1 : 0))
                    .map((item, index) => (
                      <button className={Array.from(filterLocs).includes(item) ? btnActive : btnNormal} onClick={() => setFilterLocs([...filterLocs, item])} key={index}>{item}
                      </button>
                    ))
                  }
                  <button className="btn btn-sm btn-outline-warning" title="Close LOCATIONS" onClick={() => clickLocs(true, false, false)}>Close</button>&nbsp;
                </Text>
              </Offcanvas.Body>
            </Offcanvas>
            : <span>&nbsp;</span>}
          <DataGrid
            columns={getColumns(1, 2)}
            rows={selectedRows()}
            topSummaryRows={summaryRows}
            className={themeClass}
            style={{ resize: 'vertical', height: '92vh', marginTop: '50px' }}
            defaultColumnOptions={{
              sortable: false,
              resizable: false
            }}
          />
          <div className="row-fluid">
            {(stat2) &&
              <span className="d-flex align-items-center justify-content-center shorttext ">
                {stat2}&nbsp;{stat3}
              </span>
            }
          </div>
        </div>
        : <div><h4 className="stattext">&nbsp;&nbsp;Loading Fresh Master List...</h4></div>}
    </div>
  );
};

export default MasterPanel;


function createStyles(theme) {
  // const styles = {
  //   container: isRowBased ? {flexDirection: 'row' } : {flexDirection: 'column' }
  // };

  return StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: 'column',
      // backgroundColor: 'black',
      // backgroundColor: theme.background,
    },

    textblack: {
      // color: theme.rowtext,
      color: 'white',
      fontSize: '1.1em',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      // backgroundColor: 'black',
      // flex: 2,
    },
    text: {
      fontSize: '1.1em',
      textAlign: 'left',
    },
    text1: {
      fontSize: '1.1em',
      fontWeight: 'bold',
      textAlign: 'left',
      space: 'nowrap',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    stathdr: {
      color: 'gold',
      backgroundColor: '#202',
      fontSize: '1.2em',
      textAlign: 'left',
    },

    nametext: {
      // color: 'gold',
      fontSize: '1.1em',
      textAlign: 'left',
    },
    linktext: {
      // color: 'gold',
      textDecoration: 'none',
      fontSize: '1.4em',
      textAlign: 'left'
    },
    rush: {
      color: 'red',
      fontSize: '3.0em',
      textAlign: 'center',
      // backgroundColor: theme.background,
      // backgroundColor: 'white',
      opacity: '40%',
      position: 'absolute',
      insetInlineStart: '80px',
      insetBlockStart: '-25px',
      zIndex: -5,
    },
    title: {
      // color: theme.header,
      // color: 'orange',
      fontSize: '1.5em',
      fontWeight: 'bold',
      textAlign: 'left',
      // backgroundColor: theme.background,
      // backgroundColor: 'black',
      width: "90%"
    },
    // link: {
    //   // color: theme.text,
    //   color: 'white',
    //   fontSize: 42,
    //   fontWeight: 'bold',
    //   textAlign: 'center',
    //   backgroundColor: 'rgba(16,0,16,0.7)',
    //   textDecorationLine: 'underline',
    // },
    button: {
      height: 40,
      borderRadius: 5,
      padding: 6,
      // backgroundColor: theme.button,
      backgroundColor: 'royalblue',
      justifyContent: 'center',
    },
    butttonText: {
      // color: theme.text,
      color: 'white',
      fontSize: 16,
      fontWeight: 'bold',
      textAlign: 'center',
      verticalAlign: 'middle',
      padding: 4,
    },
    icon: {
      // color: theme.text,
      color: 'white',
      fontSize: 36,
      // backgroundColor: theme.background,
      // backgroundColor: 'black',
      textAlign: 'right',
      verticalAlign: 'middle',
      padding: 1,
      width: '10%'
    },
    viewrow: {
      flexDirection: 'row',
      width: '95%',
    },
    row: {
      height: '100',
      width: '95%',
      flexDirection: 'row',
      marginBottom: 2,
      // backgroundColor: 'rgba(16,0,16,0.7)',
      // borderColor: 'white',
      // borderWidth: 2,
      // borderStyle: 'solid',
      // borderRadius: 5,
    },
    row2: {
      height: '100',
      width: '100%',
      flexDirection: 'row',
      // backgroundColor: 'black',
      marginBottom: 2,
    },
    rowodd: {
      width: '95%',
      // backgroundColor: 'black',
      borderBottomStyle: 'solid',
      borderBottomWidth: '2px',
      borderBottomColor: 'rgba(10, 134, 134, 0.4)',
    },
    roweven: {
      width: '95%',
      // backgroundColor: 'rgba(32,0,32,0.7)',
      borderBottomStyle: 'solid',
      borderBottomWidth: '2px',
      borderBottomColor: 'rgba(134, 101, 10, 0.4)',
    },


    isFail: {
      color: 'red',
      // backgroundColor: 'rgba(32,0,32,0.7)',
      fontSize: '1.2em',
    },

    failCell: {
      color: 'red',
      // backgroundColor: 'rgba(32,0,32,0.7)',
      fontSize: '1.2m',
      width: '15px',
      padding: "0px"
    },

    iconCell: {
      fontSize: '1.2m',
      width: '20px',
      padding: "0px"
    },

    timeCell: {
      color: 'lightgreen',
      fontSize: '0.9m',
      width: '100px',
      padding: "0px"
    },

    timeBase: {
      fontSize: '0.9m',
      width: '100px',
      padding: "0px",
      boxShadow: "none",
      backgroundColor: 'black',
      color: "rgb(13, 202, 240)",
    },

    timeWaiting: {
      color: 'gold',
      fontSize: '0.9m',
      width: '100px',
      padding: "0px"
    },

    timeGood: {
      color: 'lightgreen',
      fontSize: '0.9m',
      width: '100px',
      padding: "0px"
    },

    notContacted: {
      color: 'lightgray',
      // backgroundColor: 'black',
      padding: 0,
      width: '25px',
      fontSize: '.8em',
    },
    contacted: {
      color: 'gold',
      // backgroundColor: 'black',
      padding: 0,
      width: '25px',
      fontSize: '.9em',
    },

    updPhone: {
      // color: theme.header,
      textAlignVertical: "top",
      marginTop: "5px",
      borderRadius: 5,
      padding: "3px",
      color: 'black',
      fontSize: '1.3em',
      textAlign: 'left',
      width: "80%",
      // backgroundColor: theme.background,
      backgroundColor: 'lightgray'
    },
    colTots: {
      color: 'limegreen',
      fontSize: '1.3em'
    },

    sep: {
      height: 3,
      backgroundColor: 'gray',
      width: '50%',
      maxWidth: 400,
      marginHorizontal: 'auto',
      marginBottom: 2,
    },
    apptButon: {
      marginLeft: "15px",
      marginRight: "15px",
    },
    apptBase: {
      borderRadius: "5px",
      borderWidth: "1px",
      boxShadow: "none",
      borderStyle: "solid",
      borderColor: "rgb(13, 202, 240)",
      // backgroundColor: 'black',
      color: "rgb(13, 202, 240)",
    },
    apptWaiting: {
      borderRadius: "5px",
      boxShadow: "none",
      borderStyle: "solid",
      // backgroundColor: 'black',
      borderColor: "gold",
      color: 'gold'
    },
    apptGood: {
      borderRadius: "5px",
      boxShadow: "none",
      borderStyle: "solid",
      // backgroundColor: 'black',
      borderColor: "lightgreen",
      color: 'lightgreen'
    },

    selectTop: {
      position: "fixed",
      marginTop: "150px",
      display: "block",
      zIndex: "200",
      backgroundColor: "black",
      borderColor: "cornflowerblue",
      borderWidth: "3px",
      padding: "5px",
    },

    image: {
      height: '100%',
      width: 'auto',
      flex: 1,
      justifyContent: 'center',
    }
  })
}

